import { Icon } from 'car-insurance/components/common/Icon';
import classNames from 'classnames';
import React from 'react';

interface StepperProps {
  steps: { icon: string }[];
  activeStep: number;
  customWrapperStyles?: string;
}

const Stepper: React.FC<StepperProps> = ({
  steps,
  activeStep,
  customWrapperStyles,
}) => {
  return (
    <div
      className={
        customWrapperStyles
          ? customWrapperStyles
          : 'w-full flex gap-2 lg:gap-4 items-center sm:max-w-45 md:max-w-55 lg:max-w-105'
      }
    >
      {steps.map((item, index) => {
        const isCompleted = index < activeStep;
        const isActive = index === activeStep;
        return (
          <React.Fragment key={`step_${item.icon}`}>
            <div
              className={classNames(
                'size-8 md:size-10 rounded-full bg-primary-50 flex justify-center items-center shrink-0',
                {
                  'bg-primary-700': isActive || isCompleted,
                },
              )}
            >
              <Icon
                name={isCompleted ? 'done' : item.icon}
                useGoogleMaterial
                className={classNames(
                  'text-white outline-none cursor-default',
                  {
                    '!text-primary-700': index > activeStep,
                  },
                )}
              />
            </div>
            {index < steps.length - 1 && (
              <div className="h-px bg-primary-300 w-full" />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export { Stepper };
